import { useForm } from "react-hook-form";
import { MANUAL_ENTRY_CHANNELS } from "../config/manualEntryConfig";
import { recipientValidators } from "../../validations/recipientValidators";

const validators = {
  ...recipientValidators,
  channel: (v) => (v ? null : "Please select a channel"),
};

export const useManualEntryForm = () => {
  const { control, handleSubmit, reset, setValue } = useForm({
    defaultValues: {
      recipientName: "",
      phoneNumber: "",
      bankCode: "",
      accountNumber: "",
      amount: "",
      remarks: "",
      channel: MANUAL_ENTRY_CHANNELS.MPESA,
    },
    mode: "onTouched",
  });

  return { control, handleSubmit, reset, setValue, validators };
};
